module.exports = __webpack_public_path__ + "static/media/Tritronik-Logo.4e74f3a1.gif";